<mat-toolbar class="mat-toolbar-azul">
  <img [src]="logoVisorWeb" width="250" height="auto" fxHide.xs>
  <img [src]="logoVisorWeb" width="200" height="90%" fxHide.xs fxHide.sm fxHide.lg fxHide.md
    fxHide.xl>
  <span class="text-container">Proveedor</span>
  <button mat-icon-button (click)="closeDialogDetalleProveedor()" class="menu-button">
    <mat-icon matSuffix>close</mat-icon>
  </button>
</mat-toolbar>
<mat-card class="card-grey">
  <mat-card-content>
    <div class="mat-elevation-z4 div-ajusted div-full">
      <form [formGroup]="proveedorForm">
        <div class="row">
          <div class="col">
            <div class="row-flex" fxLayout="row" fxLayout.sm="column" fxLayout.xs="column" fxLayoutGap="20px">
              <div class="col" fxLayout="column">
                  <mat-form-field appearance="outline" floatLabel="always" class="field-wrapper-2em">
                      <mat-label>Referencia</mat-label>
                      <input matInput formControlName="referencia" required>
                  </mat-form-field>
              </div>
              <div class="col" fxLayout="column">
                  <mat-form-field appearance="outline" floatLabel="always" class="field-wrapper-2em">
                    <mat-label>Proveedor</mat-label>
                    <input matInput formControlName="razonSocial" required fxHide.xs>
                    <textarea matInput formControlName="razonSocial" required fxShow.xs fxHide.sm fxHide.md fxHide.lg fxHide.xl></textarea>
                </mat-form-field>
              </div>
            </div>
            <div class="row-flex" fxLayout="row" fxLayout.sm="column" fxLayout.xs="column" fxLayoutGap="20px">
              <div class="col" fxLayout="column">
                <mat-form-field appearance="outline" floatLabel="always" class="field-wrapper-2em">
                  <mat-label>Contacto</mat-label>
                  <input matInput formControlName="contacto" required fxHide.xs>
                  <textarea matInput formControlName="contacto" required fxShow.xs fxHide.sm fxHide.md fxHide.lg fxHide.xl></textarea>
                </mat-form-field>
              </div>
              <div class="col" fxLayout="column">
                <mat-form-field appearance="outline" floatLabel="always" class="field-wrapper-2em">
                    <mat-label>Actividad</mat-label>
                    <input matInput formControlName="actividad" required fxHide.xs>
                    <textarea matInput formControlName="actividad" required fxShow.xs fxHide.sm fxHide.md fxHide.lg fxHide.xl></textarea>
                </mat-form-field>
              </div>
            </div>
            <div class="row-flex">
              <div class="col" fxLayout="column">
                <mat-form-field appearance="outline" floatLabel="always" class="field-wrapper-2em">
                    <mat-label>Especialidad</mat-label>
                    <input matInput formControlName="especialidad" required fxHide.xs>
                    <textarea matInput formControlName="especialidad" required fxShow.xs fxHide.sm fxHide.md fxHide.lg fxHide.xl></textarea>
                </mat-form-field>
              </div>
            </div>
            <div class="row-flex">
              <div class="col" fxLayout="column">
                <mat-form-field appearance="outline" floatLabel="always" class="field-wrapper-2em">
                  <mat-label>Dirección</mat-label>
                  <input matInput formControlName="direccion1" required fxHide.xs fxHide.sd>
                  <textarea matInput formControlName="direccion1" required fxShow.xs fxShow.sm fxHide.sd fxHide.md fxHide.lg fxHide.xl></textarea>
                </mat-form-field>
              </div>
            </div>
            <div class="row-flex">
              <div class="col" fxLayout="column">
                <mat-form-field appearance="outline" floatLabel="always" class="field-wrapper-2em">
                  <input matInput formControlName="direccion2" required>
                </mat-form-field>
              </div>
            </div>
            <div class="row-flex" fxLayout="row" fxLayout.sm="column" fxLayout.xs="column" fxLayoutGap="20px">
              <div class="col" fxLayout="column">
                <mat-form-field appearance="outline" floatLabel="always" class="field-wrapper-2em">
                  <mat-label>Teléfono</mat-label>
                  <input matInput formControlName="telefono" required>
              </mat-form-field>
              </div>
              <div class="col" fxLayout="column">
                  <mat-form-field appearance="outline" floatLabel="always" class="field-wrapper-2em">
                    <mat-label>Fax</mat-label>
                    <input matInput formControlName="fax" required>
                </mat-form-field>
              </div>
            </div>
            <div class="row-flex" fxLayout="row" fxLayout.sm="column" fxLayout.xs="column" fxLayoutGap="20px">
              <div class="col" fxLayout="column">
                <mat-form-field appearance="outline" floatLabel="always" class="field-wrapper-2em">
                  <mat-label>Email</mat-label>
                  <input matInput formControlName="email" required>
              </mat-form-field>
              </div>
              <div class="col" fxLayout="column">
                  <mat-form-field appearance="outline" floatLabel="always" class="field-wrapper-2em">
                    <mat-label>Web</mat-label>
                    <input matInput formControlName="web" required>
                </mat-form-field>
              </div>
            </div>
            <div class="row-flex" fxLayout="row" fxLayout.sm="column" fxLayout.xs="column">
              <div class="col" fxLayout="column">
                <mat-form-field appearance="outline" floatLabel="always" class="field-wrapper-2em">
                  <mat-label>Comentario</mat-label>
                  <input matInput formControlName="comentario" required fxHide.xs>
                  <textarea matInput formControlName="comentario" required fxShow.xs fxHide.sm fxHide.md fxHide.lg fxHide.xl></textarea>
                </mat-form-field>
              </div>
            </div>
          </div>
        </div>
      </form>
    </div>
  </mat-card-content>
</mat-card>
